<template>
  <div v-show="visible" class="mt-3">
    <div class="claims-banner d-flex align-items-start justify-content-between">
      <div>
        <span class="fw-bold">Fresh data is live.</span>
        We've refreshed claims data across all providers and facilities. Claims
        are through
        <DataCoverageTimestamp
          rsDataset="last_claims_refresh"
          :options="{ month: 'long', day: 'numeric', year: 'numeric' }"
          class="d-inline-flex"
          @fetched="onFetched"
        />.
      </div>
      <button
        class="btn-close ms-3 flex-shrink-0"
        @click="visible = false"
        aria-label="Dismiss"
      />
    </div>
  </div>
</template>

<script>
import DataCoverageTimestamp from "@/components/ui/DataCoverageTimestamp.vue";

const DISMISSED_KEY = "claims_banner_dismissed_through";

export default {
  name: "ClaimsRefreshBanner",
  components: { DataCoverageTimestamp },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    onFetched({ endDate }) {
      const dismissedThrough = localStorage.getItem(DISMISSED_KEY);
      if (!dismissedThrough || endDate > dismissedThrough) {
        this.visible = true;
        // Record that the user has seen this refresh so the banner
        // only reappears if a newer refresh occurs
        localStorage.setItem(DISMISSED_KEY, endDate);
      }
    },
  },
};
</script>

<style scoped>
.claims-banner {
  border: 1px solid var(--S2NOceanBlue);
  border-left: 4px solid var(--S2NOceanBlue);
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 1px 1px 0 rgba(67, 67, 67, 0.1);
  padding: 12px 20px;
}
</style>
